// @flow

import React from "react";
import type { ResultItemContainerProps } from "../../../utils/_types";
import DefaultItem from "../DefaultItem";
import EventItem from "../EventItem";
import NewsItem from "../NewsItem";

const ResultItemContainer = (props: ResultItemContainerProps) => {
  const { "@type": portalType } = props.result;
  // let item = '';
  if (portalType === "Event") {
    return <EventItem {...props} />;
  } else if (portalType === "News Item") {
    return <NewsItem {...props} />;
  }

  return (
    <>
      <DefaultItem {...props} />
    </>
  );
};

export default ResultItemContainer;
